import React from "react";
import { useFormState } from "react-final-form";
import { getIn } from "final-form";

/**
 * Renders an array-level validation error stored under a NON-conflicting key
 * (e.g. `tiers_error`) rather than the array path itself.
 *
 * Why: final-form's processErrors does `setIn(errors, fieldName, value)` for
 * every registered field. If a scalar error is stored at `tiers` while nested
 * fields `tiers[0].threshold` exist, final-form throws
 * "Cannot set a numeric property on an object". A separate `*_error` key has
 * no nested siblings, so it is always safe.
 */
const ArrayLevelError = ({ errorKey, className = "" }) => {
  const { errors } = useFormState({ errors: true });
  const message = getIn(errors, errorKey);
  if (!message || typeof message !== "string") return null;
  return (
    <div
      role="alert"
      className={`tw-mt-1 tw-text-[12px] tw-text-red-600 ${className}`}
    >
      {message}
    </div>
  );
};

export { ArrayLevelError };
